//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import {
  IPartialState,
  NavGroup,
  StateFactory,
  hasAllFeatures,
} from 'app/initialization/routing/stateHelpers';

// Sets default values for state data
export function YouTubeStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess ?? (() => true);
  const data = {
    title: 'YouTube Account',
    navGroup: NavGroup.PUBLISHING,
    ...state.data,
    hasAccess: () =>
      hasAllFeatures(
        FeatureNames.Social,
        FeatureNames.SocialDashboards,
        // TODO: PD-269968: Remove YoutubeAnalytics Feature Flag
        FeatureNames.YoutubeAnalytics,
      ) && accessFn(),
  };

  return StateFactory({
    ...state,
    data,
  });
}
